export const TARGET_BILLING_DAY_OPTIONS = Array.from(
  { length: 28 },
  (_, i) => ({
    id: `day-${i + 1}`,
    type: "text" as const,
    text: `${i + 1}`,
    value: i + 1,
  }),
);
